const awsPaths = {
  originalImg: "local/user/profileimage",
  thumbImg: "local/user/profileimagethumb",
  companyLogo: "local/company/logo",
  productionUnit: "local/production_unit",
  certificateProductionUnit: "local/certificate/productionUnit",
  certificateProductionUnitThumb: "local/certificate/productionUnit/thumb",
  certificateIngredientsThumb: "local/certificate/ingredients/thumb",
  certificateIngredients: "local/certificate/ingredients",
  certificateManufacturerThumb: "local/certificate/manufacturer/thumb",
  certificateManufacturer: "local/certificate/manufacturer",
  certificateCoPackerThumb: "local/certificate/coPacker/thumb",
  certificateCoPacker: "local/certificate/coPacker",
  certificateEmpThumb: "local/certificate/emp/thumb",
  certificateEmp: "local/certificate/emp",
  documentManufacturer: "local/document/manufacturer",
  documentCoPacker: "local/document/coPacker",
  customerDocument: "local/document/customer",
  documentEmp: "local/document/emp",
  certificateSupplier: "local/certificate/supplier",
  ingredients: "local/ingredients",
  inventoryImages: "local/inventory/images",
  inventoryDocs: "local/inventory/docs",
  bolDocs: "local/bol/docs",
  lotDocs: "local/lot/docs",
  recipes: "local/recipes",
  recipesDocs: "local/recipes/docs",
  electronicSignature: "local/electronicSignature",
  webCamImage: "local/webCamImage",
  inspection: "local/inspections",
  taskImageThumb: "local/task/imageThumb",
  taskImage: "local/task/image",
  inspectionImageThumb: "local/inspection/imageThumb",
  inspectionImage: "local/inspection/image",
  checklistImageThumb: "local/checklist/imageThumb",
  checklistImage: "local/checklist/image",
  task: "local/task",
  recipeStep: "local/recipe/step",
  productionNoteImageThumb: "/local/productionRun/imageThumb",
  productionNote: "local/productionRun/image",
  globalCertificate: "local/globalCertificate",
  globalCertificateImageThumb: "local/globalCertificate/thumb",
  supplierCertificate: "local/globalCertificate/supplier",
  supplierCertificateThumb: "local/globalCertificate/supplier/thumb",
  manufacturerCertificate: "local/globalCertificate/manufacturer",
  manufacturerCertificateThumb: "local/globalCertificate/manufacturer/thumb",
  coPackerCertificate: "local/globalCertificate/coPacker",
  coPackerCertificateThumb: "local/globalCertificate/coPacker/thumb",
  employeeCertificate: "local/globalCertificate/employee",
  employeeCertificateThumb: "local/globalCertificate/employee/thumb",
  certificateFinishedGood: "local/certificate/finishedGood",
  certificateFinishedGoodThumb: "local/certificate/finishedGood/thumb",
  finishedGoodCertificate: "local/globalCertificate/finishedGood",
  finishedGoodCertificateThumb: "local/globalCertificate/finishedGood/thumb",
  message: "local/message",
  safetyFileThumb:"local/safety/imageThumb",
  safetyFile:"local/safety/file",
  customerOrderProof: "local/customer_order/proof",
  purchaseOrderAttachments: "local/purchase_order/attachments",
  documentControl: "local/document-control",
  equipmentAssets: "local/equipment/assets",
  finishedGoods: "local/finished-goods",
  finishedGoodSpecification: "local/finished-good/specification",
  finishedGoodNotes: "local/finished-good/notes",
};
export const awsBucketName = "foodbusinesstracker";
export const awsRegion = "us-west-2";
export const awsAccessKeyId = "AKIATSVGONKI3ISSAABF";
export const awsSecretAccessKey = "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";

// export const basePath = "https://da0ir44tr50ha.cloudfront.net";
export const basePath =
  "https://foodbusinesstracker.s3.us-west-2.amazonaws.com";

export default awsPaths;
